import React, {useEffect, useState} from 'react'
import download from 'downloadjs';
import { Dialog, DialogActions, DialogContent, DialogContentText, IconButton, ListItem, Tooltip} from '@material-ui/core'
import {Checkbox, DialogTitle, List, ListItemText} from "@mui/material";
import {Add, Add as AddIcon, Delete, Edit, AddShoppingCartOutlined, ShoppingCartOutlined} from '@material-ui/icons'
import {
  DataGridPremium,
  GridColDef, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridSortedRowIdsSelector,GridToolbarContainer, GridValueFormatterParams, useGridApiContext,
  useGridApiRef, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilteredSortedRowEntriesSelector,
} from "@mui/x-data-grid-premium";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import styles from './EventGuestLinkTable.module.css';
import {EventState, setEvent, useEventState} from "../../slices/eventSlice";
import {useParams} from "react-router";
import {useAutoEvent} from "../../queries/useAutoEvent";
import {Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Stack} from "@mui/material";
import {ButtonProps} from "@mui/material/Button";
import Button from '@mui/material/Button';
import {useQueryClient} from "react-query";
import dayjs from "dayjs";
import axios from "axios";
import {useHistory} from "react-router-dom";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import {useFetchGuestLink} from "../../queries/events/useFetchGuestLink";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@material-ui/core/Paper";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {useAutoEvt} from "../../queries/useAutoEvt";


const eventItemsDefaults = {
  id: 0,
  control: 0,
  fieldname: '',
  fieldtype: '',
  displayvalue: '',
  active: true,
  uditem: '',
  items: '',
  itemids: [],
  displayforallguest: false,
}

interface Params {
  eventid: string
}

const EventGuestLinkTable = () => {
  const { eventid } = useParams<Params>()
  useAutoEvt(eventid)
  const apiRef = useGridApiRef();
  const queryClient = useQueryClient()
  const eventState = useEventState()
  const [dialogUpload, setDialogUpload] = React.useState({ msg: "", id: 0, open: false, uploadCount: null, uploadDuplicates: null })
  const { data, isLoading } = useFetchGuestLink( Number(eventid) )
  const [isDataLoading, setIsDataLoading] = React.useState(false)
  const [checkboxSelection, setCheckboxSelection] = React.useState([])
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [tabValue, setTabValue] = React.useState(0);
  const history = useHistory()
  var rows = []

  if (data) {
    console.log(data)
    rows = data.map((item) => {
      return { id: item.guestid, ...item}
    })
  }

  const useStyles = makeStyles((theme: Theme) =>
      createStyles({
        button: {
          margin: theme.spacing(1),
          paddingLeft: 10,
          marginLeft: 10,
          marginRight: 10,
        },
        paper: {
          padding: theme.spacing(2),
          spacing: theme.spacing(100),
          paddingLeft: 10,
          marginLeft: 10,
          marginRight: 10,
          marginBottom: 20,
          textAlign: 'left',
          fontSize: 15,
          color: theme.palette.text.secondary
        }
      })
  )
  const classes = useStyles()

  const guestupload = async () => {
    setIsDataLoading(true)
    const body = {
      'eventid': eventid,
      'idlist': checkboxSelection.map(cbSels => {return cbSels.id})
    }
    const response = await axios.post(`guestlinkuploadpre`, body)
    const parsedData = JSON.parse(response.data.jsonString)
    console.log(parsedData.uploadcount)
    console.log(parsedData.duplicates)

    setIsDataLoading(false)

    setDialogUpload({ msg: "", id: 0, open: true, uploadCount: parsedData.uploadcount, uploadDuplicates: parsedData.duplicates })
  }

  const guestautolink = () => {
    setIsDataLoading(true)
    const body = {eventid: eventid}
    axios.post(`guestlinkauto`, body).then(response => {
      console.log(response)
      const parsedData = JSON.parse(response.data.jsonString)
      setDialogOpen(true);
      setDialogMessage(parsedData.message);
      queryClient.invalidateQueries(['guestlink'])
      setIsDataLoading(false)
    })
  }

  const downloadInteractionExcel = async () => {
    setIsDataLoading(true)
    axios.post('/evtguestinteractionexport', {eventid: eventid}, {responseType: "blob"}).then(response => {
      var filename = eventState.eventName + '-Guest.xlsx';
      var disposition = response.headers['content-disposition']
      var contentType = response.headers['content-type']
      if (disposition && disposition.indexOf('attachment') !== -1) {
        console.log(disposition);
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      if (response.data) {
        download(response.data, filename, contentType);
      }
      setIsDataLoading(false)
    })
  }

  const downloadExcel = async () => {
    setIsDataLoading(true)
    axios.post('/guestlinkreport', {eventid: eventid}, {responseType: "blob"}).then(response => {
      var filename = eventState.eventName + '-Guest.xlsx';
      var disposition = response.headers['content-disposition']
      var contentType = response.headers['content-type']
      if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      if (response.data) {
        download(response.data, filename, contentType);
      }
      setIsDataLoading(false)
    })
  }

  const closeDialog = () => {
    setDialogUpload({ msg: "", id: 0, open: false, uploadCount: [], uploadDuplicates: [] })
  }

  const guestlinkupload = async () => {
    setIsDataLoading(true)
    const body = {
      'eventid': eventid,
      'idlist': checkboxSelection.map(cbSels => {return cbSels.id})
    }
    const response = await axios.post(`guestlinkupload`, body)
    const parsedData = JSON.parse(response.data.jsonString)
    console.log(parsedData.uploadcount)
    console.log(parsedData.duplicates)

    queryClient.invalidateQueries(['guestlink'])

    setIsDataLoading(false)
    setDialogUpload({ msg: "", id: 0, open: false, uploadCount: [], uploadDuplicates: [] })
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxSel(event.target.id, event.target.checked)
  }
  const setCheckboxSel = (id, value) => {
    const selections = checkboxSelection.filter((op) => op.id != id)
    if (id == 0) {
      if (value) {
        const gridFilteredRows = gridFilteredSortedRowEntriesSelector(apiRef)
        const selectedItems = gridFilteredRows.map(listofstuff => {
          return {id: listofstuff.id, value: value}
        })
        setCheckboxSelection([{id: 0, value: value}, ...selectedItems])
      }
      else {
        setCheckboxSelection([])
      }
      // console.log(value)
    }
    else {
      const selectionValues = [{id: Number(id), value: value}, ...selections].filter((op) => op.id != 0)
      const allValue = shouldAllBeSelected(selectionValues)

      selectionValues.push({id: 0, value: allValue})
      setCheckboxSelection(selectionValues)
    }
  }

  const shouldAllBeSelected = (selections) => {
    var allSelected = true
    selections.forEach(listofstuff => {
      if (listofstuff.value == false) {
        allSelected = false
      }
    })
    return allSelected
  }

  const getCheckboxSel = (id) => {
    const selection = checkboxSelection.find((op) => op.id === id)
    return selection ? selection.value : false
  }

  const linkGuest = (guestid) => {
    const body = {eventid: eventid, guestid: guestid}
    axios.put(`guestunlink`, body).then(response => {
      const json = JSON.parse(data.jsonString)

      if (json.status === "failure") {
        setDialogOpen(true)
        setDialogMessage(json.message)
      }
      else {
        queryClient.invalidateQueries(['guestlink'])
      }

    })
  }

  var checkboxCol: GridColDef = {
    "field": 'checkedeContactid',
    "headerName":'',
    "type": 'string',
    "headerAlign": 'right',
    "width": 180,
    "align": 'right',
  }
  checkboxCol = GRID_CHECKBOX_SELECTION_COL_DEF
  checkboxCol.field = 'checkedeContactid'
  checkboxCol.headerName = ''
  checkboxCol.width = 120
  checkboxCol.renderHeader = (params) => {
    return (
        <Checkbox
            name={'0'}
            id={'0'}
            checked={getCheckboxSel(0)}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
            size="medium"
        />
    )
  }
  checkboxCol.renderCell = (params) => {
    if (params.row.contactid) {
      return (
          <div>{params.row.contactid}</div>
      )
    }
    else {
      return (
          <Checkbox
              name={params.row.id}
              id={params.row.id}
              checked={getCheckboxSel(params.row.id)}
              onChange={handleChange}
              inputProps={{'aria-label': 'controlled'}}
              size="medium"
          />
      )
    }
  }

  const columns: GridColDef[] = [
    {
      field: 'button',
      headerName: 'Link',
      width: 130,
      disableExport: true,
      sortable: false,
      renderCell: (params) => {
        if(params.row.contactid > 0) {
          return <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                linkGuest(params.row.guestid)
                // Scotty
                // const body = {eventid: eventid, guestid: params.row.guestid}
                // axios.put(`guestunlink`, body).then(response => {
                //   queryClient.invalidateQueries(['guestlink'])
                // })
              }}>
            UnLink
          </Button>;
        }
        return  <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push({
                pathname: '/event/' + eventid + '/eventguestlinking',
                state:{
                  data: params.row,
                }}
              )
            }}>
          Link
        </Button>;

      }
    },
    checkboxCol,
    {
      field: 'first',
      headerName: 'First',
      type: 'string',
      width: 180,
      // valueFormatter: (params: GridValueFormatterParams) => {
      //   return dayjs(params.value as string).format('MM/DD/YYYY hh:mm A')
      // },
    },
    {
      field: 'last',
      type: 'string',
      headerName: 'Last',
      width: 180
    },
    {
      field: 'email',
      type: 'string',
      headerName: 'Email',
      minWidth: 250
    },
    {
      field: 'phone',
      headerName: 'Phone',
      width: 180,
      valueFormatter: (params) => {
        var cleaned = ('' + params.value).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        return match
            ? '(' + match[1] + ') ' + match[2] + '-' + match[3]
            : params.value
      },
    },
    {
      field: 'attended',
      type: 'string',
      headerName: 'Attended',
      width: 120,
      align: "right",
    },
    {
      field: 'ticketnames',
      type: 'string',
      headerName: 'Ticket Type',
      minWidth: 300
    },
    {
      field: 'purchasernames',
      type: 'string',
      headerName: 'Purchaser',
      minWidth: 300
    },
    {
      field: 'address',
      type: 'string',
      headerName: 'Address',
      minWidth: 400,
      valueGetter: (gridParams) => {
          const addressValue = gridParams.row?.address + ' ' + gridParams.row?.city + (gridParams.row?.city.length > 0 ? ', ' : ' ') + gridParams.row?.state + ' ' + gridParams.row?.zip
          return addressValue
      }
    },
  ]
  const getUnfilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
      gridSortedRowIdsSelector(apiRef);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  function CustomGridToolbar() {
    const apiRef = useGridApiContext();

    const handleExport = (options: GridCsvExportOptions) => {
      options.allColumns = true;
      apiRef.current.exportDataAsCsv(options);
    }

    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };

    const getTicketItemOptions = () => {
      return data?.ticketitemlist?.map(item => (
          <MenuItem key={item.ticketitemid} value={item.ticketitemid}>
            {item.ticketitemname}
          </MenuItem>
      ))
    }

    const handleSelectionChange = async (event: SelectChangeEvent) => {
      console.log(event.target.value)
      // setTicketItem(event.target.value as string);
    }

    return (
        <>
          <GridToolbarContainer >
            <>
              <Grid
                  container
                  direction="row"
                  justifyContent="flex-begin"
                  alignItems="center"
                  // border={2}
                  xs={3} sm={4} md={4}
              >
                <Grid item xs={12}>
                  <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin', marginTop: '5px', marginBottom: '5px'}} >
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => {guestautolink()}}
                        color="primary">
                      AUTOLINK
                    </Button>
                  </InputLabel>
                </Grid>
              </Grid>
              <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  xs={2} sm={6} md={8}
              >
                <Button
                    {...buttonBaseProps}
                    onClick={() => handleExport({getRowsToExport: getUnfilteredRows})}
                >
                  EXPORT
                </Button>
                {/*<GridToolbarExport style={{color: '#00b2ff'}}/>*/}
              </Grid>
            </>
          </GridToolbarContainer>
        </>
    )
  }

  return (
      <div className={styles.root}>
        <h1>Event Guest Link / Transfer</h1>
      <>
        <Dialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Auto Link Status"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
            open={dialogUpload.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogTitle>Upload Guests to DonorSnap</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You are about to upload {dialogUpload?.uploadCount} guests into your DonorSnap account. Are you sure you want to continue?
            </DialogContentText>
            {dialogUpload?.uploadDuplicates?.length > 0 &&
                <><DialogContentText id="alert-dialog-description">
                  <b>NOTICE:</b> You selected multiple guests records with the same email address. This will create a
                  new contact for each one, potentially duplicate contacts.
                </DialogContentText><List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
                  {dialogUpload?.uploadDuplicates?.map((value) => (
                      <ListItem
                          key={value?.email}
                          disableGutters
                      >
                        <ListItemText primary={value?.email} />
                      </ListItem>
                  ))}
                </List></>
            }
          </DialogContent>
          <DialogActions>
            <Button variant="contained"
                    color="primary"
                    onClick={closeDialog}>CANCEL
            </Button>
            <Button variant="contained"
                    color="primary"
                    disabled={isDataLoading}
                    onClick={guestlinkupload}>UPLOAD TO DonorSnap</Button>
          </DialogActions>
        </Dialog>
      </>

      <LoadingBackdrop open={isDataLoading} />
      <div>
        <Tabs style={{marginBottom: 10}} value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab label="Contact" {...a11yProps(0)} />
          <Tab label="Interaction" {...a11yProps(1)} />
        </Tabs>
          {tabValue === 0 && (
              <>
                <DataGridPremium
                  autoHeight
                  rows={rows}
                  columns={columns}
                  apiRef={apiRef}
                  components={{
                    Toolbar: CustomGridToolbar,
                    // Footer: CustomGridToolbar,
                  }}
                  componentsProps={{ toolbar: { csvOptions: { allColumns: true }}}}
                />

                <Stack direction="row" spacing={2}>
                  <Button
                      style={{width: '100%'}}
                      variant="contained"
                      size="small"
                      onClick={() => {guestupload()}}
                      disabled={isDataLoading || checkboxSelection.length === 0}
                      color="primary">
                    UPLOAD SELECTED GUESTS TO DONORSNAP
                  </Button>
                  <Button
                      style={{width: '100%'}}
                      variant="contained"
                      size="small"
                      onClick={() => {downloadExcel()}}
                      color="primary">
                    EXPORT ALL TO EXCEL
                  </Button>
                </Stack>
              </>
            )}
            {tabValue === 1 && (
                <>
                  <Paper className={classes.paper}>Export guest ticket information to Excel to customize interaction data for import into DonorSnap</Paper>
                  <Button
                      style={{width: '100%'}}
                      variant="contained"
                      size="small"
                      onClick={() => {downloadInteractionExcel()}}
                      color="primary">
                    EXPORT TO EXCEL
                  </Button>
                </>
            )}
      </div>
    </div>
  )
}

export default EventGuestLinkTable
